/**
 * Is the Polymarket US lane on for this deployment? One probe per session
 * (the relay's `/api/polymarket-us/status` answers 503
 * POLYMARKET_US_NOT_CONFIGURED when the lane is off), cached so the sidebar
 * and the page never re-ask. Presentation only: the relay gates every request.
 */
import { create } from 'zustand';
import { fetchPolymarketUsStatus, PolymarketUsRelayError } from '@/lib/polymarketUs/relay';

export type PolymarketUsLaneStatus = 'unknown' | 'on' | 'off';

interface PolymarketUsLaneState {
  status: PolymarketUsLaneStatus;
  probing: boolean;
  probe: () => Promise<void>;
  reset: () => void;
}

export const usePolymarketUsLaneStore = create<PolymarketUsLaneState>((set, get) => ({
  status: 'unknown',
  probing: false,
  probe: async () => {
    if (get().probing || get().status !== 'unknown') return;
    set({ probing: true });
    try {
      await fetchPolymarketUsStatus();
      set({ status: 'on', probing: false });
    } catch (err) {
      if (err instanceof PolymarketUsRelayError && err.laneOff) {
        set({ status: 'off', probing: false });
      } else if (err instanceof PolymarketUsRelayError && err.status !== 401 && err.status !== 403) {
        // Any other relay answer means the route exists — the lane is on.
        set({ status: 'on', probing: false });
      } else {
        set({ probing: false });
      }
    }
  },
  reset: () => set({ status: 'unknown', probing: false }),
}));
